import React, { useState, useEffect } from 'react';
import { ChakraProvider, theme } from '@chakra-ui/react';
import Header from './components/Header';
import About from './screens/About';
import { useLocation, Switch, Route } from 'react-router-dom';
import Skills from './screens/Skills';
import Projects from './screens/Projects';
import { AnimatePresence, useViewportScroll, motion } from 'framer-motion';

function App() {
  const [focused, setFocused] = useState(false);
  const location = useLocation();
  const { scrollY } = useViewportScroll();

  useEffect(() => {
    const handleScroll = () => {
      if (scrollY.current >= 75) {
        setFocused(true);
      } else {
        setFocused(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [scrollY]);

  return (
    <ChakraProvider theme={theme}>
      <motion.div
        className="overlay"
        style={{
          maxWidth: '100vw',
          backgroundColor: focused ? 'rgba(0,0,0,0.6)' : 'rgba(0,0,0,0)',
          transition: 'linear .2s',
        }}
      >
        <Header />
        <AnimatePresence exitBeforeEnter>
          <Switch location={location} key={location.key}>
            <Route exact path="/">
              <About focused={focused} setFocused={setFocused} />
            </Route>
            <Route path="/skills">
              <Skills focused={focused} setFocused={setFocused} />
            </Route>
            <Route path="/projects">
              <Projects focused={focused} setFocused={setFocused} />
            </Route>
          </Switch>
        </AnimatePresence>
      </motion.div>
    </ChakraProvider>
  );
}

export default App;
